import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Parfums from "@/pages/Parfums";
import Gouter from "@/pages/Gouter";
import NousRetrouver from "@/pages/NousRetrouver";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/nos-parfums" element={<Parfums />} />
                        <Route path="/gouter" element={<Gouter />} />
                        <Route path="/nous-retrouver" element={<NousRetrouver />} />
                        <Route path="/mentions-legales" element={<MentionsLegales />} />
                        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
